import React from "react";

const MenuIcon = ({ name, size = 22, style={}, hover=false, active=false, ...rest }) => {
  
  const path = process.env.PUBLIC_URL + `/images/icons/menu/${name}.svg`
  const classes = `p-2 rounded-full ${active ? "bg-gray-100" : ""} ${hover ? "hover:bg-gray-100 cursor-pointer" : ""}`

  return (
    <div className={classes} {...rest}>
      <div
        style={{
          backgroundImage: `url(${path})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          width: `${size}px`,
          height: `${size}px`,
          ...style,
        }}
      />
    </div>
  );
};

export default MenuIcon;
